// extracted by mini-css-extract-plugin
module.exports = {"container":"GeneralSearchComponent_container__1jIV2","input":"GeneralSearchComponent_input__3mflS","iconButton":"GeneralSearchComponent_iconButton__1xCL2"};